import "./index.css";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { ServicesSection } from "./components/ServicesSection";
import { CaseStudiesSection } from "./components/CaseStudiesSection";
import { ProcessSection } from "./components/ProcessSection";
import { ClientsSection } from "./components/ClientsSection";
import { AdvantagesSection } from "./components/AdvantagesSection";
import { PricingSection } from "./components/PricingSection";
import { ContactSection } from "./components/ContactSection";

export default function App() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <HeroSection />
      
      {/* About AdHub */}
      <AboutSection />
      
      {/* Services Overview */}
      <ServicesSection />
      
      {/* Case Studies */}
      <CaseStudiesSection />
      
      {/* Process Section */}
      <ProcessSection />
      
      {/* Clients & Partners */}
      <ClientsSection />
      
      {/* Competitive Advantages */}
      <AdvantagesSection />
      
      {/* Pricing */}
      <PricingSection />
      
      {/* Contact Section */}
      <ContactSection />
      
      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <div className="mb-4">
            <h3 className="text-2xl font-bold text-orange-400 mb-2">AdHub</h3>
            <p className="text-gray-400">Connect brands, activate growth</p>
          </div>
          <div className="border-t border-gray-800 pt-4">
            <p className="text-gray-500">© 2025 AdHub. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
